export default "__VITE_ASSET__BSj17$qZ__"